import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const policyEditorColumnSizingAtom = atomWithStorage<Record<string, number>>(
    'tymely-policyEditor-column-sizing',
    {},
);

export const actionMetadataColumnSizingAtom = atomWithStorage<Record<string, number>>(
    'tymely-actionMetadata-column-sizing',
    {},
);

export const argMetadataColumnSizingAtom = atomWithStorage<Record<string, number>>(
    'tymely-argMetadata-column-sizing',
    {},
);

export const policyEditorSearchQueryAtom = atom<string>('');

export type ThemeMode = 'light' | 'dark';

export const drawerThemeModeAtom = atomWithStorage<ThemeMode>('tymely-drawer-theme-mode', 'light');
